callingBack = {
    init: function () {

        //  Current time vars
        var d = new Date(),
            currentWeekday = d.getDay(),
            currentHour = d.getHours(),
            currentMinutes = d.getMinutes();

        var element = $('.js-call-me-back');

        //  Selected weekdays in backend vars
        var selectedWeekdays = element.data('time-days').toString(),
            weekday = false;

        //  Selected from working time in backend vars
        var timeFrom = element.data('time-from').split(':'),
            timeFromHours = parseInt(timeFrom[0]),
            timeFromMinutes = parseInt(timeFrom[1]),
            fromTime = false;

        //  Selected till working time in backend vars
        var timeTo = element.data('time-to').split(':'),
            timeToHours = parseInt(timeTo[0]),
            timeToMinutes = parseInt(timeTo[1]),
            toTime = false;

        //  Button object vars
        var telButton = $('.js-time-tel'),
            formButton = $('.js-time-form');

        //  Check if weekday is selected in backend
        if (selectedWeekdays.indexOf(currentWeekday) >= 0) {
            weekday = true;
        }

        //  Check From time
        if (currentHour >= timeFromHours) {
            fromTime = true;

            //  If current hour is the same
            //  The minutes could make the difference
            if (currentHour === timeFromHours) {
                fromTime = (currentMinutes >= timeFromMinutes);
            }
        }

        //  Check To time
        if (currentHour <= timeToHours) {
            toTime = true;

            //  If current hour is the same
            //  The minutes could make the difference
            if (currentHour === timeToHours) {
                toTime = (currentMinutes < timeToMinutes);
            }
        }

        //  Check if weekday is checked
        //  And if current time is between selected working hours
        if (fromTime && toTime && weekday) {
            //  If true show call button
            telButton.removeClass('is-hidden');
            formButton.addClass('is-hidden');
        } else {
            //  If false show call me back button
            formButton.removeClass('is-hidden');
            telButton.addClass('is-hidden');
        }
    }
}


// WEBPACK FOOTER //
// ./resources/js/modules/callingBack.js